export const setCookie = (name, value, expiresInSeconds) => {
    let cookieStr = `${name}=${encodeURIComponent(value)}; path=/`;
    if (expiresInSeconds) {
        const expires = new Date(Date.now() + expiresInSeconds * 1000).toUTCString();
        cookieStr += `; expires=${expires}`;
    }
    document.cookie = cookieStr;
};
